// extracted by mini-css-extract-plugin
export default {"__inputStyle__":"input___inputStyle____FzYix","textarea":"input_textarea__tf6Kt"};